import { ENUM__debug_feature_client } from '@/_debug/ENUM__debug_feature_client';
import { UI_PRIMITIVE__tabs, UI_PRIMITIVE__tabs_list, UI_PRIMITIVE__tabs_trigger } from '@/components/ui/UI_PRIMITIVE__tabs';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { UTILS__array } from '@shared/utils/utils_array';
import { useRef } from 'react';
import { ENUM__page_generation_layout } from '../../_enums/ENUM__page_generation_layout';

export function G_BAR__layout_tabs() {
  const dispatch = use_dispatch();

  const { g_general__layout } = use_slice_ui(['g_general__layout']);

  let allowed_tabs = get_allowed_tabs();

  const ref_active_item = useRef<HTMLButtonElement | null>(null);

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (!ref_active_item.current) return;

    ref_active_item.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [g_general__layout]); // Re-run whenever the selected tab changes

  /*
   * EVENTS
   */

  let class_name_item = 'shrink-0 flex items-center justify-start h-full  text-[10px] leading-none py-0 overflow-hidden text-bar-foreground';

  function onValueChange(value: string) {
    dispatch(LOCAL__ui_set_string({ value, key: 'g_general__layout', valid_values: allowed_tabs }));
  }

  function get_allowed_tabs() {
    let out = Object.values(ENUM__page_generation_layout);

    if (!ENUM__debug_feature_client.ENABLE_PAGE_BUNDLES) UTILS__array.delete_value(out, ENUM__page_generation_layout.BUNDLES);
    if (!ENUM__debug_feature_client.ENABLE_PAGE_NODES) UTILS__array.delete_value(out, ENUM__page_generation_layout.NODES);
    if (!ENUM__debug_feature_client.ENABLE_PAGE_EDITOR_2D) UTILS__array.delete_value(out, ENUM__page_generation_layout.EDITOR);

    return out;
  }

  /*
   * HTML
   */

  return (
    <div className="flex-shrink-0 w-full h-6 overflow-auto flex flex-row items-center justify-start gap-2  border-b border-component-border">
      <UI_PRIMITIVE__tabs defaultValue={g_general__layout} value={g_general__layout} orientation="horizontal" className="h-full w-full" {...{ onValueChange }}>
        <UI_PRIMITIVE__tabs_list className="flex flex-row size-full items-stretch justify-start dark:bg-page rounded-none">
          {allowed_tabs.map(tab => {
            const is_active = tab === g_general__layout;
            return (
              <UI_PRIMITIVE__tabs_trigger
                ref={is_active ? ref_active_item : null}
                key={tab}
                value={tab}
                className={`${class_name_item} ${tab == g_general__layout ? '!bg-component' : ''}`}
              >
                {tab}
              </UI_PRIMITIVE__tabs_trigger>
            );
          })}
        </UI_PRIMITIVE__tabs_list>
      </UI_PRIMITIVE__tabs>
    </div>
  );
}
